import { useShallow } from "zustand/react/shallow";

import { useStore } from "../store";

export function useEnvironmentStoreSnapshot() {
  return useStore(
    useShallow((state) => ({
      activeEnvironmentId: state.activeEnvironmentId,
      environmentStateById: state.environmentStateById,
    })),
  );
}
